var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-wrapper"},[_c('basic-container',[_c('div',{attrs:{"slot":"header-left"},slot:"header-left"},[_vm._v("分步表单 -- 带验证")]),_c('step-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }